import { IconAdjustments, IconTicket, IconPlus } from '@tabler/icons-react';

import { Button, Text } from '@fragments';

import FiltersSection from './components/FiltersSection';
import MetricsSection from './components/MetricsSection';
import SalesAmountChart from './components/SalesAmountChart';
import RevenueChart from './components/RevenueChart';
import ProductRevenueChart from './components/ProductRevenueChart';

import './styles.scss';

export default function InsightsView(props) {
    const { ownedCommunities, communitiesLoading, community, plans, plansLoading } = props;

    if (!communitiesLoading && !ownedCommunities.length) {
        return (
            <div className="insights-page">
                <NoCommunitiesState />
            </div>
        );
    }

    const showInsights = community && !plansLoading && plans.length > 0;
    const showNoPlans = community && !plansLoading && plans.length === 0;

    return (
        <div className="insights-page">
            <div className="insights-page__filters-wrap mb-4">
                <Text.h4
                    contrast={7}
                    left={<IconAdjustments/>}
                    className="mb-1"
                >
                    Filtros
                </Text.h4>
                <FiltersSection {...props} />
            </div>

            {showInsights && (
                <>
                    <MetricsSection {...props} />
                    <div className="insights-page__charts-grid mt-3">
                        <SalesAmountChart {...props} />
                        <RevenueChart {...props} />
                    </div>
                    <div className="insights-page__chart-row mt-3">
                        <ProductRevenueChart {...props} />
                    </div>
                </>
            )}

            {showNoPlans && (
                <NoPlansState
                    community={ownedCommunities.find(c => c.id === community)}
                />
            )}
        </div>
    );
}

function NoCommunitiesState() {
    return (
        <div className="insights-page__empty">
            <Text.h4 contrast={7}>
                Você precisa ser dono de uma comunidade para ver os insights.
            </Text.h4>
            <Text.p contrast={5} className="mt-1">
                Crie uma comunidade ou peça acesso de proprietário para começar.
            </Text.p>
        </div>
    );
}

function NoPlansState({ community }) {
    function handleCreatePlan() {
        if (!community?.slug) return;
        window.navigate(`/${community.slug}/settings/pricing`);
    }

    return (
        <div className="insights-page__empty">
            <IconTicket className='csf-2 mb-1' size={40}/>
            <Text.h4 contrast={7} weight={400}>
                Esta comunidade ainda não tem planos cadastrados.
            </Text.h4>
            <Text.h5 contrast={5} className="mt-1">
                Crie um plano para começar a ver os insights de vendas.
            </Text.h5>
            <Button
                className="mt-3"
                size="medium"
                startIcon={<IconPlus size={16} stroke={2} />}
                text="Criar plano"
                color="inverse"
                onClick={handleCreatePlan}
            />
        </div>
    );
}
